import { render, staticRenderFns } from "./CapitalShiftToHistoryForAppropriation.vue?vue&type=template&id=34fbc662&scoped=true&"
import script from "./CapitalShiftToHistoryForAppropriation.vue?vue&type=script&lang=ts&"
export * from "./CapitalShiftToHistoryForAppropriation.vue?vue&type=script&lang=ts&"
import style0 from "./CapitalShiftToHistoryForAppropriation.vue?vue&type=style&index=0&id=34fbc662&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fbc662",
  null
  
)

export default component.exports